import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form } from 'reactstrap';
import classes from './AddTruckModal.module.scss'
import moment from "moment-timezone";
import {DebounceInput} from 'react-debounce-input';

import closeIcon from '../../../assets/icons/close.svg'
import axios from "axios";


const config = {
  headers: {
    "Content-Type": "application/json"
  },
  withCredentials: true
};

const AddTruckModal = ({ isEditing, isModalOpen, openModal, trucks, placeholders, addCampaignTruck, updateCampaignTruck, campaignTruckToEdit }) => {

  // Truck States
  const [truckSearchInput, setTruckSearchInput] = useState('')
  const [filteredTrucks, setFilteredTrucks] = useState([])
  const [selectedTruck, setSelectedTruck] = useState([])
  const [truckDisplayName, setTruckDisplayName] = useState(campaignTruckToEdit && isEditing ? campaignTruckToEdit.displayName : '')

  // Macro States
  const [macroSearchInput, setMacroSearchInput] = useState('')
  const [filteredMacros, setFilteredMacros] = useState([])
  const [selectedMacro, setSelectedMacro] = useState([])
  
  // Remaining States
  const [selectedGPSProvider, setSelectedGPSProvider] = useState(campaignTruckToEdit && isEditing ? campaignTruckToEdit.gps_provider : "Clearpath")
  const [avgMileage, setAvgMileage] = useState(campaignTruckToEdit && isEditing ? campaignTruckToEdit.avgMileage : 0)
  const [daysDrivenPerWeek, setDaysDrivenPerWeek] = useState(campaignTruckToEdit && isEditing ? campaignTruckToEdit.daysDrivenPerWeek : 0)
  const [startDate, setStartDate] = useState(campaignTruckToEdit && isEditing ? moment(campaignTruckToEdit.startDate).utc().format('YYYY-MM-DD') : null)
  const [isFormValid, setFormValid] = useState(false)
  const [truckMacroErrMsg, setTruckMacroErrMsg] = useState(null)
  const [trackingErrMsg, setTrackingErrMsg] = useState(null)
  const [displayErrMsg, setDisplayErrMsg] = useState(null)
  const [avgMileageErrMsg, setAvgMileageErrMsg] = useState(null)

  // const [endDate, setEndDate] = useState(campaignTruckToEdit && isEditing ? moment(campaignTruckToEdit.endDate).utc().format('YYYY-MM-DD') : null)

  useEffect(() => {
    if (campaignTruckToEdit && isEditing) {
      console.log(campaignTruckToEdit);
      getTruck(campaignTruckToEdit.truckId)
      getMacro(campaignTruckToEdit.macroId)
      setTruckDisplayName(campaignTruckToEdit.displayName)
      setAvgMileage(campaignTruckToEdit.avgMileage)
      setDaysDrivenPerWeek(campaignTruckToEdit.daysDrivenPerWeek)
      setStartDate(moment(campaignTruckToEdit.startDate).format('YYYY-MM-DD'))
      setSelectedGPSProvider(campaignTruckToEdit.gps_provider)
      // setEndDate(moment(campaignTruckToEdit.endDate).utc().format('YYYY-MM-DD'))
    }
    console.log(campaignTruckToEdit);
  }, [campaignTruckToEdit, isEditing])

  const getTruck = async (truckId) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/truck/${truckId}`, { withCredentials: true });
      console.log(res.data.truck[0]);
      const truck = res.data.truck[0]
      setSelectedTruck([truck.truck_id, truck.vendor_id, truck.name, truck.license_plate])
    } catch (err) {
      console.error(err) 
    }
  }

  const getMacro = async (macroId) => {
    try {
      let res = await axios.get(`${process.env.REACT_APP_API_HOST}/placeholder/${macroId}`, { withCredentials: true });
      console.log(res.data.placeholder[0]);
      const placeholder = res.data.placeholder[0]
      setSelectedMacro([placeholder.placeholder_id, placeholder.name, placeholder.min_mileage, placeholder.max_mileage, placeholder.min_impressions, placeholder.max_impressions, placeholder.num_stops])
    } catch (err) {
      console.error(err) 
    }
  }

  const filterTrucks = (e) => {
    setTruckSearchInput(e.target.value)
    if (e.target.value !== '') {
      const filtered = trucks.filter((truck) => {
        return truck[1]?.toLowerCase().includes(e.target.value.toLowerCase()) || truck[2]?.toLowerCase().includes(e.target.value.toLowerCase())
      })

      setFilteredTrucks(filtered)
    } else setFilteredTrucks([])
  }

  const filterMacros = (e) => {
    setMacroSearchInput(e.target.value)
    if (e.target.value !== '') {
      const filtered = placeholders.filter((macro) => {
        return macro[1]?.toLowerCase().includes(e.target.value.toLowerCase())
      })
  
      setFilteredMacros(filtered)
    } else setFilteredMacros([])
  }

  const selectTruck = (truck) => {
    setTruckMacroErrMsg(null)
    setSelectedTruck(truck)
    setFilteredTrucks([])
    setTruckSearchInput("")
  }

  const selectMacro = (macro) => {
    setTruckMacroErrMsg(null)
    setFilteredMacros([])
    setMacroSearchInput("")
    setSelectedMacro(macro)
  }
  
  const removeTruck = () => {
    selectTruck([])
  }
  
  const removeMacro = () => {
    selectMacro([])
  }
  
  useEffect(() => {
  }, [isFormValid])

  const addTruck = (e) => {
    e.preventDefault();

    if (selectedTruck.length == 0 && selectedMacro.length == 0) { setTruckMacroErrMsg('No Truck or Macro selected. Please select one of them!'); setFormValid(false); }
    if (!startDate) { setTrackingErrMsg('Please select a tracking start date!'); setFormValid(false); }
    if (truckDisplayName.length == 0) { setDisplayErrMsg('Please select a display name!'); setFormValid(false); }
    if (!avgMileage) { setAvgMileageErrMsg('Please provide average mileage!'); setFormValid(false); }
    else setFormValid(true)
    console.log(isFormValid);
    setTimeout(() => {
      if (isFormValid) {
        addCampaignTruck(selectedTruck.length > 0 ? selectedTruck[0] : 'NULL', selectedMacro.length > 0 ? selectedMacro[0] : 'NULL', truckDisplayName, avgMileage, daysDrivenPerWeek && daysDrivenPerWeek !== 0 ? daysDrivenPerWeek : 7, moment(startDate).utc().startOf('day'), selectedTruck.length > 0 ? selectedTruck[3] : 'NULL', selectedGPSProvider);
        resetState();
        openModal();
      } 
    }, 100);
  }

  const updateTruck = (e) => {
    e.preventDefault();
    if (selectedTruck.length == 0 && selectedMacro.length == 0) { setTruckMacroErrMsg('No Truck or Macro selected. Please select one of them!'); setFormValid(false); }
    if (!startDate) { setTrackingErrMsg('Please select a tracking start date!'); setFormValid(false); }
    if (truckDisplayName.length == 0) { setDisplayErrMsg('Please select a display name!'); setFormValid(false); }
    if (!avgMileage) { setAvgMileageErrMsg('Please provide average mileage!'); setFormValid(false); }
    else setFormValid(true)

    setTimeout(() => {
      if ((selectedTruck.length !== 0 || selectedMacro.length !== 0) && startDate && truckDisplayName.length > 0 && avgMileage) {
        updateCampaignTruck(selectedTruck[0], selectedTruck[1], selectedTruck[2], selectedMacro[0], selectedMacro[1], truckDisplayName, selectedTruck[3], moment(startDate).utc().startOf('day'), avgMileage, daysDrivenPerWeek && daysDrivenPerWeek !== 0 ? daysDrivenPerWeek : 7, selectedGPSProvider);
        resetState();
        openModal();
      }
    }, 100);
  }

  const resetState = () => {
    setTruckSearchInput('')
    setFilteredTrucks([])
    setSelectedTruck([])
    setTruckDisplayName('')
    setMacroSearchInput('')
    setFilteredMacros([])
    setSelectedMacro([])
    setSelectedGPSProvider("Clearpath")
    setAvgMileage(0)
    setDaysDrivenPerWeek(0)
    setStartDate(null)
    setFormValid(false)
    setTruckMacroErrMsg(null)
    setTrackingErrMsg(null)
    setDisplayErrMsg(null)
    setAvgMileageErrMsg(null)
  }
 
  const formOnChange = (e) => {
    if (e.target.id == 'search-truck' || e.target.id == 'search-macro') setTruckMacroErrMsg(null)
    else if (e.target.id == 'tracking-start') setTrackingErrMsg(null)
    else if (e.target.id == 'display-name') setDisplayErrMsg(null)
    else if (e.target.id == 'avg-mileage') setAvgMileageErrMsg(null)
  }

  return (
    <>
      <Modal className={classes.modalDialog} isOpen={isModalOpen} toggle={openModal}>
        <ModalHeader toggle={openModal}>{isEditing ? 'Update Campaign Truck' : 'Add Truck to Campaign'}</ModalHeader>
        <ModalBody>
          <Form onChange={(e) => formOnChange(e)} onSubmit={isEditing ? updateTruck : addTruck}>
            <div className={classes.split}>
              {/* Truck */}
              <div>
                <div className={classes.input}>
                  <Label for="search-truck">Search for a Truck{' '}<span style={{color: '#FFBF00'}}>^</span></Label>
                  <DebounceInput
                    id="search-truck"
                    value={truckSearchInput}
                    disabled={selectedTruck.length > 0}
                    element={Input}
                    placeholder="Search Truck..."
                    minLength={2}
                    debounceTimeout={700}
                    onChange={(e) => filterTrucks(e)} />
                </div>
                
                {filteredTrucks && filteredTrucks.length > 0 && selectedTruck.length === 0 && <div style={{ marginTop: 16 }}>Click on a truck to select:</div>}
                <div className={classes.trucksContainer}>
                  {filteredTrucks && filteredTrucks.map((truck, index) => {
                    return (
                      <div onClick={() => selectTruck(truck)} key={index} className={classes.truckCard}>
                        <div>Truck ID: <span>{truck[0]}</span></div>
                        <div>Vendor Name: <span>{truck[1]}</span></div>
                        <div>Truck Name: <span>{truck[2]}</span></div>
                        <div>License Plate #: <span>{truck[3]}</span></div>
                      </div>
                    )
                  })}
                </div>

                {filteredTrucks.length === 0 && selectedTruck.length > 0 && 
                  <>
                    <div>Selected Truck:</div>
                    <div className={classes.truckCard} style={{ marginBottom: 20 }}>
                      {/* <div>Display Name: <span className={classes.underline}>{truckDisplayName}</span></div> */}
                      <div>Truck ID: <span>{selectedTruck[0]}</span></div>
                      <div>Vendor Name: <span>{selectedTruck[1]}</span></div>
                      <div>Truck Name: <span>{selectedTruck[2]}</span></div>
                      <div>License Plate #: <span>{selectedTruck[3]}</span></div>
                      <img onClick={() => removeTruck()} className={classes.close} src={closeIcon} />
                    </div>

                  </>
                }

                {selectedTruck && selectedTruck.length > 0 && 
                  <>
                    <div>Select the GPS Provider:</div>
                    <div className={classes.gpsProviderRadioGroup}>
                      <div>
                        <input type="radio" value="Clearpath" checked={selectedGPSProvider == 'Clearpath'} onChange={(e) => setSelectedGPSProvider(e.target.value)} /><label>Clearpath</label>
                      </div>
                      <div>
                        <input type="radio" value="Linxup" checked={selectedGPSProvider == 'Linxup'} onChange={(e) => setSelectedGPSProvider(e.target.value)} /><label>Linxup</label>
                      </div>
                    </div>
                  </>
                }
              </div>

              {/* Macro */}
              <div>
                <div className={classes.input}>
                  <Label for="search-macro">Search for a Macro{' '}<span style={{color: '#FFBF00'}}>^</span></Label>
                  <DebounceInput
                    id="search-macro"
                    value={macroSearchInput}
                    disabled={selectedMacro.length > 0}
                    element={Input}
                    placeholder="Search Macro..."
                    minLength={2}
                    debounceTimeout={700}
                    onChange={(e) => filterMacros(e)} />
                </div>
                
                {filteredMacros && filteredMacros.length > 0 && selectedMacro.length === 0 && <div style={{ marginTop: 16 }}>Click on a Macro to select:</div>}
                <div className={classes.trucksContainer}>
                  {filteredMacros && filteredMacros.map((macro, index) => {
                    return (
                      <div onClick={() => selectMacro(macro)} key={index} className={classes.truckCard}>
                        <div>Macro Name: <span>{macro[1]}</span></div>
                        <div>Min Mileage: <span>{macro[2]}</span></div>
                        <div>Max Mileage: <span>{macro[3]}</span></div>
                        <div>No. of stops: <span>{macro[6]}</span></div>
                      </div>
                    )
                  })}
                </div>

                {filteredMacros.length === 0 && selectedMacro.length > 0 && 
                  <>
                    <div>Selected Macro:</div>
                    <div className={classes.truckCard} style={{ marginBottom: 20 }}>
                      <div>Macro Name: <span>{selectedMacro[1]}</span></div>
                      <div>Min Mileage: <span>{selectedMacro[2]}</span></div>
                      <div>Max Mileage: <span>{selectedMacro[3]}</span></div>
                      <div>No. of stops: <span>{selectedMacro[6]}</span></div>
                      <img onClick={() => removeMacro()} className={classes.close} src={closeIcon} />
                    </div>

                  </>
                }
              </div>
            </div>
            {truckMacroErrMsg && <p style={{color: 'red', fontSize: 12, margin: 0, marginTop: -16}}>{truckMacroErrMsg}</p>}

            <div className={classes.split} style={{ marginBottom: 16 }}>
              <div>
                <Label for="tracking-start">Tracking Start Date{' '}<span style={{color: 'red'}}>*</span></Label>
                <Input
                  id="tracking-start"
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(moment(new Date(`${e.target.value} UTC`)).utc().format('YYYY-MM-DD'))}
                />
              </div>
              {/* <div>
                <Label for="tracking-end">Tracking End Date</Label>
                <Input
                  id="tracking-end"
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(moment(new Date(`${e.target.value} UTC`)).utc().format('YYYY-MM-DD'))}
                />
              </div> */}
            </div>
            {trackingErrMsg && <p style={{color: 'red', fontSize: 12, margin: 0, marginTop: -16}}>{trackingErrMsg}</p>}

            <div className={classes.splitGroup} style={{ marginTop: 16, marginBottom: 16 }}>
              <div>
                <Label for="display-name">Display Name{' '}<span style={{color: 'red'}}>*</span></Label>
                <Input id="display-name" value={truckDisplayName} onChange={(e) => setTruckDisplayName(e.target.value)} placeholder="Display Name" />
                <p style={{color: 'red', fontSize: 12}}>{displayErrMsg && displayErrMsg}</p>
              </div>
              <div>
                <Label for="avg-mileage">Average Mileage{' '}<span style={{color: 'red'}}>*</span></Label>
                <Input id="avg-mileage" type="number" value={+avgMileage} onChange={(e) => setAvgMileage(+e.target.value)} placeholder="Add Average Mileage (in miles)" />
                <p style={{color: 'red', fontSize: 12}}>{avgMileageErrMsg && avgMileageErrMsg}</p>
              </div>
              <div>
                <Label for="days-driven-per-week">Days Driven Per Week</Label>
                <Input id="days-driven-per-week" type="number" value={+daysDrivenPerWeek} onChange={(e) => setDaysDrivenPerWeek(+e.target.value)} placeholder="Add Days Driven Per Week" />
              </div>
            </div>

            <div style={{display: 'flex', alignItems: 'center', columnGap: 16, fontSize: 14}}>
              <div><span style={{color: '#FFBF00'}}>^</span> One of them is required</div>
              <div><span style={{color: 'red'}}>*</span> Required</div>
            </div>
          </Form>
        </ModalBody>
        <ModalFooter>
          {!isEditing ? 
            <>
              <Button color="primary" onClick={addTruck}>
                Add Truck
              </Button>{' '}
            </>
            :
            <>
              <Button color="primary" onClick={updateTruck}>
                Update Truck
              </Button>{' '}
            </>
          }
          <Button color="secondary" onClick={openModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default AddTruckModal